import React from "react";
import _ from "lodash";
import HelperValidate from "utils/helper-validate";
import ThemedSelect from 'components/atoms/ThemedSelect'
import isEqual from 'react-fast-compare'
import { StyleSheet } from 'react-native'

const ThemedTimePicker = ({ time = '00:00:00', style = {}, empty = null, min, max, onSelect, disabled = false, testID = null, minuteInterval = 15 }) => {
	
	const onChange = ( value ) => {
		time = null;
		if( value !== null ) {
			const valueSplit = value.split(':');
			
			time = new Date();
			time.setHours( valueSplit[ 0 ] );
			time.setMinutes( valueSplit[ 1 ] );
			time.setSeconds(0 );
			
			const timeArray = [
				String( time.getHours() ).padStart( 2, '0' ),
				String( time.getMinutes() ).padStart( 2, '0' ),
				String( time.getSeconds() ).padStart( 2, '0' )
			];
			
			time = timeArray.join(':');
		}
		
		if ( _.isFunction( onSelect ) ) {
			onSelect( time );
		}
	}
	
	const date = new Date();
	const timeSplit = HelperValidate.isValid( time ) ? time.split(':') : [];
	
	date.setHours(
		_.get( timeSplit, 0, '0' ),
		_.get( timeSplit, 1, '0' ),
		_.get( timeSplit, 2, '0' )
	);
	
	let minDate = null;
	if( min ) {
		minDate = new Date();
		const minSplit = min.split(':');
		minDate.setHours( minSplit[ 0 ], minSplit[ 1 ], minSplit[ 2 ] )
	}
	
	let maxDate = null;
	if( max ) {
		maxDate = new Date();
		const maxSplit = max.split(':');
		maxDate.setHours( maxSplit[ 0 ], maxSplit[ 1 ], maxSplit[ 2 ] )
	}
	
	const options = [];
	if( empty !== null ) {
		options.push({
			value: null,
			label: empty
		})
	}
	
	const hours = _.range( 0, 23 );
	_.forEach( hours, (hour, hourKey) => {
		const isLast = ( _.size( hours ) - 1 ) === hourKey;
		
		const minutes = isLast ? [ 0 ] : _.map( _.range( 0, 60 / minuteInterval ), ( minute ) => {
			return minute * minuteInterval;
		} );
		_.forEach( minutes, minute => {
			
			// Created padded hour/minute
			const hourPad = String( hour ).padStart( 2, '0' );
			const minutePad = String( minute ).padStart( 2, '0' );
			
			// Create the value
			const value = `${ hourPad }:${ minutePad }`;
			
			//
			const valueDate = new Date();
			valueDate.setHours( hour, minute, 0 );
			
			// Validate with min and max
			
			// If the new value is less than the min date.. do not show
			if( minDate !== null && valueDate <= minDate ) {
				return;
			}
			
			if( maxDate !== null && valueDate >= maxDate ) {
				return;
			}
			
			if( _.find( options, { value: value } ) === undefined ) {
				options.push({
					value: value,
					label: value
				})
			}
		})
	})
	
	const dateHourPad = String( date.getHours() ).padStart( 2, '0' );
	const dateMinutePad = String( date.getMinutes() ).padStart( 2, '0' );
	
	return (
		<ThemedSelect
			placeholder={ null }
			options={ options }
			select={ onChange }
			selected={ time == null ? null : `${dateHourPad}:${dateMinutePad}` }
			style={[ styles.select, style ]}
			disabled={ disabled }
			testID={ testID }
		/>
	)
}

const styles = StyleSheet.create({
	select: {
		flex: 1,
	}
});

export default React.memo( ThemedTimePicker, isEqual );
